import { PageResp } from 'src/app/core/models/page/page-response';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AnnouncementTableRequest } from '../pages/announcement/interface/announcement-table-request';
import { AnnouncementTableResponse } from '../pages/announcement/interface/announcement-table-response';
import { HttpClient } from '@angular/common/http';
import { AnnouncementEditParams } from '../pages/announcement/interface/announcement-edit-params';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  private messageSource = new Subject<any>();
  message$ = this.messageSource.asObservable();

  constructor(private http: HttpClient) { }

  setMessage(msg: any) {
    this.messageSource.next(msg);
  }

  searchAnnouncementTable(request: AnnouncementTableRequest): Observable<PageResp<AnnouncementTableResponse>> {
    const url = `${environment.customerserviceApiUrl}/announcement/getTableAnnouncement`
    return this.http.post<PageResp<AnnouncementTableResponse>>(url,request);
  }

  searchAnnouncementEdit(seqNo: number): Observable<AnnouncementEditParams> {
    const url = `${environment.customerserviceApiUrl}/announcement/getAnnouncementContent/${seqNo}`
    return this.http.get<AnnouncementEditParams>(url);
  }

  // saveAnnouncementEdit(request: AnnouncementEditParams): Observable<any> {
  //   const url = `${environment.logisticsApiUrl}/announcement/updateEditAnnouncement`
  //   return this.http.put(url,request);
  // }

  uploadAnnouncementFile(request: any): Observable<any> {
    const url = `${environment.customerserviceApiUrl}/announcementFileUpload/upload`
    return this.http.put(url,request);
  }

  saveEditAnnouncement(request: AnnouncementEditParams): Observable<any> {
    const url = `${environment.customerserviceApiUrl}/announcement/updateEditAnnouncement`
    return this.http.put(url,request);
  }
  saveCopyAnnouncement(request: AnnouncementEditParams): Observable<any> {
    const url = `${environment.customerserviceApiUrl}/announcement/updateCopyAnnouncement`
    return this.http.put(url,request);
  }
  saveNewAnnouncement(request: AnnouncementEditParams): Observable<any> {
    const url = `${environment.customerserviceApiUrl}/announcement/updateNewAnnouncement`
    return this.http.put(url,request);
  }

  updateCancelAnnouncement(seqNo: number): Observable<any>{
    const url = `${environment.customerserviceApiUrl}/announcement/updateCancelAnnouncement/${seqNo}`
    return this.http.put(url,seqNo);
  }

  downloadAnnouncementFile(docId: string, name: string, type:string): Observable<any> {
    const url = `${environment.customerserviceApiUrl}/announcementFileUpload/getAnnouncementFile/${docId}/${name}.${type}`;
    return this.http.get(url, {
      responseType: 'blob'
    });
  }
}
